<div class="container-fluid">
	<div class="row flex-nowrap">

		<div id="menu-panel" class="col-auto d-none d-md-block">

			<div class="menu-header text-center">
				<i class="fa fa-4x fa-building page-icon"></i>
			</div>

			<div>
				<div class="text-center">LISTA</div>
				<button id="filter-btn" class="btn btn-dark pl-3 pr-3 mb-2 disabled"><i class="fa fa-lg mb-2 fa-search"></i><br />Szűrő</button><br />
				<button class="btn btn-primary pl-3 pr-3" onclick="Anvil.page.refresh()"><i class="fa fa-lg mb-2 fa-sync-alt"></i><br />Frissítés</button>
			</div>
		</div>

		<div class="col list-panel">

			<div class="row">
				<div class="col">

					<div class="page-header">

						<div class="float-end pt-4" style="width:300px; max-width:50vw;">
							<div class="input-group">
								<input type="text" class="form-control" id="status-search" placeholder="Keresés..." oninput="Anvil.page.quickSearch($(this).val())" />
								<span class="input-group-text"><i class="fa fa-search"></i></span>
							</div>
						</div>

						<h2>Termék audit</h2>
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/home"><i class="fa fa-home"></i></a></li>
							<li class="breadcrumb-item">Termék menedzsment</li>
							<li class="breadcrumb-item">c-Order</li>
							<li class="breadcrumb-item active">Termék audit</li>
						</ol>
					</div>

					<% for (const company_db_name in list) { %>
						<%
						const products = list[company_db_name].products
						if (products.length == 0) continue

						const company_db = Anvil.page.company_dbs.data.find(db => db.db_name == company_db_name)
						var company_name = '[ ismeretlen cég ]'
						if (company_db) {
							const company = Anvil.page.companies.getById(company_db.company_id)
							if (company) company_name = company.name
						}
						%>
						<h3><%= company_name %> - <i class="fa fa-server me-2"></i><%= company_db_name %></h3>
						<table class="table table-dark table-hover table-sm grid-table w-100 mb-3">
							<thead>
								<th width="5%">ID</th>
								<th width="45%" colspan="3">Termék neve</th>
								<th width="15%">NTAK Főkategória</th>
								<th width="15%">NTAK Alkategória</th>
								<th width="10%">Elviteles áfa</th>
								<th width="10%">Helyben fogyasztásos áfa</th>
							</thead>
							<tbody>
								<% for (const product of products) { %>
								<% if (!product.on_premise_tax) product.on_premise_tax = product.tax; %>
								<tr>
									<td><%= product.id %></td>
									<td><%= product.name %></td>
									<td><%= product.engname %></td>
									<td><%= product.chnname %></td>
									<td><%- product.ntak_category || '<span class="text-warning">[nincs besorolás]</span>' %></td>
									<td><%- product.ntak_subcategory || '<span class="text-warning">[nincs besorolás]</span>' %></td>
									<td>
										<% if ((product.ntak_category == 'ALKOHOLOSITAL' || product.ntak_category == 'ALKMENTESITAL_NEM_HELYBEN' || product.ntak_category == 'ALKMENTESITAL_HELYBEN') && product.tax != '27') { %>
											<span class="text-warning"><%= product.tax %><i class="fa fa-question-circle ms-2"></i></span>
										<% } else { %>
											<%= product.tax %>
										<% } %>
									</td>
									<td>
										<% if ((product.ntak_category == 'ALKOHOLOSITAL' || product.ntak_category == 'ALKMENTESITAL_NEM_HELYBEN') && product.on_premise_tax != '27') { %>
											<span class="text-danger"><%= product.on_premise_tax %><i class="fa fa-exclamation-circle ms-2"></i></span>
										<% } else if (product.ntak_category == 'ALKMENTESITAL_HELYBEN' && product.on_premise_tax != '5') { %>
											<span class="text-warning"><%= product.on_premise_tax %><i class="fa fa-question-circle ms-2"></i></span>
										<% } else { %>
											<%= product.on_premise_tax %>
										<% } %>
									</td>
								</tr>
								<% } %>
							</tbody>
						</table>
					<% } %>
				</div>
			</div>

		</div>

	</div>
</div>

<script>
Object.assign(Anvil.page, {

})
</script>
